import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Search, Grid, List, Filter, ChevronRight, Package, Award, Star } from 'lucide-react';
import truper from '../../assets/img/logos/truper.png';
import pretul from '../../assets/img/logos/pretul.png';
import foset from '../../assets/img/logos/foset.png';
import volteck from '../../assets/img/logos/volteck.png';
import fiero from '../../assets/img/logos/fiero.png';
import hermex from '../../assets/img/logos/hermex.png';
import klintek from '../../assets/img/logos/klinteck.png';
import catalogoTruper from '../../assets/pdf/CatalogoTruper.pdf';

// ─── Constantes ────────────────────────────────────────────────────────────────

//const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';
const API_URL = process.env.REACT_APP_API_URL || '';

const marcasInfo = {
    truper:  { name: 'Truper',   logo: truper,   color: '#E31E24', destacado: true  },
    pretul:  { name: 'Pretul',   logo: pretul,   color: '#0066CC', destacado: false },
    foset:   { name: 'Foset',    logo: foset,    color: '#FF6600', destacado: false },
    volteck: { name: 'Volteck',  logo: volteck,  color: '#00AEEF', destacado: false },
    fiero:   { name: 'Fiero',    logo: fiero,    color: '#FF0000', destacado: false },
    hermex:  { name: 'Hermex',   logo: hermex,   color: '#009639', destacado: false },
    klintek: { name: 'Klintek',  logo: klintek,  color: '#1E3A8A', destacado: false },
};

const marcasArray = Object.entries(marcasInfo).map(([id, info]) => ({ id, ...info }));

const categorias = [
    { id: 'todas',        name: 'Todas las Categorías' },
    { id: 'construccion', name: 'Construcción'          },
    { id: 'jardineria',   name: 'Jardinería'            },
    { id: 'carpinteria',  name: 'Carpintería'           },
    { id: 'electrico',    name: 'Eléctrico'             },
    { id: 'plomeria',     name: 'Plomería'              },
];

// ─── Componente ────────────────────────────────────────────────────────────────

function Productos() {
    const [selectedMarca,     setSelectedMarca]     = useState('todas');
    const [searchTerm,        setSearchTerm]        = useState('');
    const [viewMode,          setViewMode]          = useState('grid');
    const [selectedCategoria, setSelectedCategoria] = useState('todas');

    const [productos,  setProductos]  = useState([]);
    const [loading,    setLoading]    = useState(true);
    const [error,      setError]      = useState(null);

    // ── Fetch a la API de Django ───────────────────────────────────────────────
    useEffect(() => {
        const fetchProductos = async () => {
            setLoading(true);
            setError(null);
            try {
                const params = new URLSearchParams();
                if (selectedMarca     !== 'todas') params.append('marca',     selectedMarca);
                if (selectedCategoria !== 'todas') params.append('categoria', selectedCategoria);
                if (searchTerm.trim())             params.append('search',    searchTerm.trim());

                const res = await fetch(`${API_URL}/api/productos/?${params}`);
                if (!res.ok) throw new Error(`Error ${res.status}: ${res.statusText}`);
                const data = await res.json();
                setProductos(data);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        // Pequeño debounce para el buscador
        const timer = setTimeout(fetchProductos, 300);
        return () => clearTimeout(timer);
    }, [selectedMarca, selectedCategoria, searchTerm]);

    // ── Helpers ───────────────────────────────────────────────────────────────
    

    const getImagenUrl = (producto) => {
        if (!producto.imagen) return null;
        // Si Django devuelve la URL completa (cuando se usa request en el serializer)
        if (producto.imagen.startsWith('http')) return producto.imagen;
        return `${API_URL}${producto.imagen}`;
    };

    // ─────────────────────────────────────────────────────────────────────────

    return (
        <section className="showroom-section">
            {/* Fondo decorativo */}
            <div className="showroom-background">
                <div className="showroom-shape showroom-shape-1"></div>
                <div className="showroom-shape showroom-shape-2"></div>
                <div className="showroom-pattern"></div>
            </div>

            <Container className="showroom-container">
                {/* Header */}
                <div className="showroom-header text-center">
                    <div className="showroom-badge">
                        <Package size={20} />
                        <span>Nuestro Catálogo</span>
                    </div>
                    <h1 className="showroom-title">
                        Showroom de <span className="text-highlight-showroom">Productos</span>
                    </h1>
                    <p className="showroom-subtitle">
                        Explora nuestra amplia gama de productos de las mejores marcas internacionales
                    </p>
                    <div className="title-divider-showroom"></div>
                </div>

                {/* Stats */}
                <Row className="showroom-stats g-4 mb-5">
                    <Col md={4} xs={6}>
                        <div className="stat-card">
                            <div className="stat-icon"><Award size={28} /></div>
                            <div className="stat-number">7</div>
                            <div className="stat-label">Marcas Líderes</div>
                        </div>
                    </Col>
                    <Col md={4} xs={6}>
                        <div className="stat-card">
                            <div className="stat-icon"><Package size={28} /></div>
                            <div className="stat-number">+8000</div>
                            <div className="stat-label">Productos</div>
                        </div>
                    </Col>
                    <Col md={4} xs={6}>
                        <div className="stat-card">
                            <div className="stat-icon"><Star size={28} /></div>
                            <div className="stat-number">100%</div>
                            <div className="stat-label">Calidad</div>
                        </div>
                    </Col>
                </Row>

                {/* Filtros de Marcas */}
                <div className="marcas-filter-section">
                    <h3 className="filter-title">Filtrar por Marca</h3>
                    <div className="marcas-filter-grid">
                        <div
                            className={`marca-filter-item ${selectedMarca === 'todas' ? 'active' : ''}`}
                            onClick={() => setSelectedMarca('todas')}
                        >
                            <div className="marca-filter-content">
                                <div className="marca-filter-icon"><Grid size={32} /></div>
                                <span className="marca-filter-name">Todas</span>
                            </div>
                        </div>

                        {marcasArray.map((marca, index) => (
                            <div
                                key={marca.id}
                                className={`marca-filter-item ${selectedMarca === marca.id ? 'active' : ''} ${marca.destacado ? 'destacado' : ''}`}
                                onClick={() => setSelectedMarca(marca.id)}
                                style={{ animationDelay: `${index * 0.1}s` }}
                            >
                                <div className="marca-filter-content">
                                    <img src={marca.logo} alt={marca.name} className="marca-filter-logo" />
                                    <span className="marca-filter-name">{marca.name}</span>
                                </div>
                                {marca.destacado && (
                                    <div className="destacado-badge">
                                        <Star size={14} /> Principal
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                </div>

                {/* Barra de búsqueda */}
                <div className="search-filter-bar">
                    <Row className="g-3 align-items-center">
                        <Col lg={5}>
                            <div className="search-box">
                                <Search size={20} className="search-icon" />
                                <input
                                    type="text"
                                    placeholder="Buscar productos..."
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                    className="search-input"
                                />
                            </div>
                        </Col>
                        <Col lg={5}>
                            <div className="categoria-filter">
                                <Filter size={20} className="filter-icon" />
                                <select
                                    value={selectedCategoria}
                                    onChange={(e) => setSelectedCategoria(e.target.value)}
                                    className="categoria-select"
                                >
                                    {categorias.map(cat => (
                                        <option key={cat.id} value={cat.id}>{cat.name}</option>
                                    ))}
                                </select>
                            </div>
                        </Col>
                        <Col lg={2}>
                            <div className="view-mode-toggle">
                                <button className={`view-btn ${viewMode === 'grid' ? 'active' : ''}`} onClick={() => setViewMode('grid')}>
                                    <Grid size={20} />
                                </button>
                                <button className={`view-btn ${viewMode === 'list' ? 'active' : ''}`} onClick={() => setViewMode('list')}>
                                    <List size={20} />
                                </button>
                            </div>
                        </Col>
                    </Row>
                </div>

                {/* Productos */}
                <div className="productos-section">
                    <div className="productos-header">
                        <h3 className="productos-title">
                            {selectedMarca === 'todas'
                                ? 'Todos los Productos'
                                : `Productos ${marcasInfo[selectedMarca]?.name}`}
                        </h3>
                        {!loading && (
                            <span className="productos-count">{productos.length} productos</span>
                        )}
                    </div>

                    {/* Estado de carga */}
                    {loading && (
                        <div className="no-productos">
                            <Package size={48} className="spin" />
                            <h3>Cargando productos...</h3>
                        </div>
                    )}

                    {/* Estado de error */}
                    {!loading && error && (
                        <div className="no-productos">
                            <Package size={64} />
                            <h3>Error al cargar productos</h3>
                            <p>{error}</p>
                        </div>
                    )}

                    {/* Grid / List de productos */}
                    {!loading && !error && (
                        <Row className={`productos-${viewMode} g-4`}>
                            {productos.map((producto, index) => {
                                const marcaInfo = marcasInfo[producto.marca];
                                const imagenUrl = getImagenUrl(producto);

                                return (
                                    <Col
                                        key={producto.id}
                                        xs={12}
                                        sm={viewMode === 'grid' ? 6  : 12}
                                        md={viewMode === 'grid' ? 4  : 12}
                                        lg={viewMode === 'grid' ? 3  : 12}
                                    >
                                        <div
                                            className={`producto-card producto-card-${viewMode}`}
                                            style={{ animationDelay: `${index * 0.05}s` }}
                                        >
                                            {/* Imagen */}
                                            <div className="producto-imagen">
                                                {imagenUrl ? (
                                                    <img
                                                        src={imagenUrl}
                                                        alt={producto.descripcion}
                                                        className="producto-img"
                                                        onError={(e) => { e.target.style.display = 'none'; }}
                                                    />
                                                ) : (
                                                    <div className="imagen-placeholder">
                                                        <Package size={48} />
                                                    </div>
                                                )}
                                                {marcaInfo && (
                                                    <div className="producto-marca-badge">
                                                        <img src={marcaInfo.logo} alt={producto.marca} />
                                                    </div>
                                                )}
                                            </div>

                                            {/* Info */}
                                            <div className="producto-info">
                                                
                                                <h4 className="producto-nombre text-center">{producto.descripcion}</h4>
                                                <p className="producto-codigo text-muted small mb-1 text-center">
                                                    · {producto.codigo} · 
                                                </p>
                                                <p className="producto-categoria text-center">{producto.categoria_display}</p>

                                                {/* Precios */}
                                                {/* <div className="producto-precios mb-2">
                                                    <div className="precio-item">
                                                        <span className="precio-label">Menudeo</span>
                                                        <span className="precio-valor precio-menudeo">
                                                            {formatPrecio(producto.precio_menudeo)}
                                                        </span>
                                                    </div>
                                                    <div className="precio-item">
                                                        <span className="precio-label">Mayoreo</span>
                                                        <span className="precio-valor precio-mayoreo">
                                                            {formatPrecio(producto.precio_mayoreo)}
                                                        </span>
                                                    </div>
                                                </div> */}

                                                <div className="producto-footer">
                                                    <button className="producto-btn">
                                                        <span>Ver más</span>
                                                        <ChevronRight size={16} />
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </Col>
                                );
                            })}
                        </Row>
                    )}

                    {/* Sin resultados */}
                    {!loading && !error && productos.length === 0 && (
                        <div className="no-productos">
                            <Package size={64} />
                            <h3>No se encontraron productos</h3>
                            <p>Intenta con otros filtros o términos de búsqueda</p>
                        </div>
                    )}
                </div>

                {/* CTA Final */}
                <div className="showroom-cta">
                    <h3 className="cta-title-showroom">¿No encuentras lo que buscas?</h3>
                    <p className="cta-description-showroom">
                        Contáctanos y te ayudaremos a encontrar el producto perfecto para tus necesidades
                    </p>
                    <div className="cta-buttons-showroom">
                        <a href="/contacto" className="btn-showroom-cta">
                            Contáctanos <ChevronRight size={20} />
                        </a>
                        <a href={catalogoTruper} className="btn-download" download="Catalogo-Completo.pdf">
                            Descarga Catálogo Completo <ChevronRight size={20} />
                        </a>
                    </div>
                </div>
            </Container>
        </section>
    );
}

export default Productos;